import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import { FontIcon } from 'react-toolbox/lib/font_icon';
import styles from './FileUploadInput.css';

export const parseExtension = name =>
  name.match(/\.[^.]*$|$/i)[0].toLowerCase();

export const acceptRegex = accept =>
  new RegExp(
    '^(' + accept.replace(/[, ]+/g, '|').replace(/\/\*/g, '/.*') + ')$',
    'i',
  );

export const isValidType = (accept, type) =>
  !accept || acceptRegex(accept).test(type);

export const isValidExtension = (accept, extension) =>
  !accept || acceptRegex(accept).test(extension);

export const isValidAccept = (accept, file) =>
  !accept ||
  (isValidType(accept, file.type) ||
    isValidExtension(accept, parseExtension(file.name)));

export const isValidMaxSize = (maxSize, size) => {
  if (!maxSize && typeof maxSize !== 'number') {
    return true;
  }

  const maxSizeNum = parseInt(maxSize, 10);
  return isNaN(maxSizeNum) ? false : size <= maxSizeNum;
};

const offsetTarget = event => {
  const boundingRect = event.target.getBoundingClientRect();

  const documentOffset = {
    left: boundingRect.left + document.documentElement.scrollLeft,
    top: boundingRect.top + document.documentElement.scrollTop,
  };

  return {
    left: event.pageX - documentOffset.left,
    top: event.pageY - documentOffset.top,
  };
};

const stopEvent = e => {
  e.stopPropagation();
  e.preventDefault();
};

const initialState = {
  draggedOver: false,
  rippleOffset: {
    top: 0,
    left: 0,
  },
};

class FileUploadInput extends React.Component {
  constructor(props) {
    super(props);

    this.refCount = 0;
    this.state = initialState;
  }

  fileChanged(file) {
    if (!isValidAccept(this.props.accept, file)) {
      return;
    }

    if (!isValidMaxSize(this.props.maxSize, file.size)) {
      return;
    }

    if (this.props.onChange) {
      this.props.onChange(file);
    }
  }

  fileRemoved() {
    if (this.props.onChange) {
      this.props.onChange(null);
    }

    this.fileInput.value = null;
  }

  dragHandler(handler) {
    return e => {
      stopEvent(e);

      if (!this.props.value && handler) {
        handler(e);
      }
    };
  }

  getDropZoneClassName() {
    return this.state.draggedOver
      ? styles.dropZoneDraggedOver
      : styles.dropZone;
  }

  render() {
    return (
      <div className={`${styles.container} ${this.props.className}`}>
        <div
          className={`${this.getDropZoneClassName()} ${this.props.error
            ? styles.dropZoneError
            : ''}`}
          onDragOver={this.dragHandler()}
          onDragEnter={this.dragHandler(e => {
            this.refCount++;

            if (this.refCount === 1) {
              this.setState({
                draggedOver: true,
                rippleOffset: offsetTarget(e),
              });
            }
          })}
          onDrop={this.dragHandler(e => {
            this.refCount = 0;

            this.setState(initialState);
            this.fileChanged(e.dataTransfer.files[0]);
          })}
          onDragLeave={this.dragHandler(() => {
            this.refCount--;

            if (this.refCount === 0) {
              this.setState(initialState);
            }
          })}
        >
          <div className={styles.selectFileRow}>
            <div
              className={styles.ripple}
              style={{
                left: this.state.rippleOffset.left - 10,
                top: this.state.rippleOffset.top - 10,
              }}
            />
            <input
              className={styles.fileInput}
              ref={fileInput => (this.fileInput = fileInput)}
              type="file"
              accept={this.props.accept}
              onChange={e => this.fileChanged(e.currentTarget.files[0])}
            />
            <Button
              onClick={() => this.fileInput.click()}
              raised
              primary
              disabled={!!this.props.value}
            >
              Select File
            </Button>
            <FontIcon className={styles.uploadIcon} value="file_upload" />
            <span className={styles.dropHere}>Drop file here...</span>
          </div>
          {this.props.value &&
            <div className={styles.fileNameRow}>
              <span className={styles.fileName}>
                {this.props.value.name}
              </span>
              <FontIcon
                className={styles.closeButton}
                value="close"
                onClick={() => this.fileRemoved()}
              />
            </div>}
        </div>
        {this.props.error &&
          <div className={styles.errorRow}>
            <span className={styles.errorLabel}>
              {this.props.error}
            </span>
          </div>}
      </div>
    );
  }
}

export default FileUploadInput;



// WEBPACK FOOTER //
// ./src/general-components/FileUploadInput.js